import { JSONPath } from "jsonpath-plus";
import * as R from "remeda";

import type { RequestParameter } from "../../DropdownDimensionHelpers";

import type {
    DataDimensionInput,
    DataDimensionValueBaseConfig,
} from "./dimension.data.value";
import {
    DataDimensionValue,
    DataDimensionValueType,
} from "./dimension.data.value";

export interface DataDimensionValueJsonConfig
    extends DataDimensionValueBaseConfig {
    type: DataDimensionValueType.JSON;
    settings?: {
        jsonPath?: string;
        useObjectAsRequestParameter?: boolean;
    };
}

export class DataDimensionValueJson extends DataDimensionValue {
    constructor(dimensionId: string, config: DataDimensionValueJsonConfig) {
        super(dimensionId, config);
        this.config = config;
    }

    type = DataDimensionValueType.JSON;
    config: DataDimensionValueJsonConfig;
    dataParsed: undefined | DataDimensionInput;

    protected handler(input: DataDimensionInput): string {
        const data = this.config?.settings?.jsonPath
            ? JSONPath({
                  path: this.config.settings.jsonPath,
                  wrap: false,
                  json: input,
              })
            : input;

        this.dataParsed = data;

        return typeof data === "string" ? data : JSON.stringify(data);
    }

    getRequestParameter(
        _input: DataDimensionInput,
        _handlerOutput: string,
    ): RequestParameter {
        const { useObjectAsRequestParameter = true } = this.config.settings || {
            useObjectAsRequestParameter: true,
        };
        if (R.isNullish(this.dataParsed)) {
            throw new Error("cannot set request parameter with no data");
        } else if (typeof this.dataParsed === "string") {
            return {
                [this.id]: this.dataParsed,
            };
        } else if (typeof this.dataParsed === "number") {
            return {
                [this.id]: this.dataParsed.toString(),
            };
        } else if (typeof this.dataParsed === "object") {
            const output = {
                [this.id]: JSON.stringify(this.dataParsed),
            };

            if (useObjectAsRequestParameter) {
                const additionalOutput: Record<string, string> = {};
                for (const key in this.dataParsed) {
                    additionalOutput[key] =
                        typeof this.dataParsed[key] === "string"
                            ? this.dataParsed[key]
                            : JSON.stringify(this.dataParsed[key]);
                }
                return {
                    ...output,
                    ...additionalOutput,
                };
            } else {
                return output;
            }
        } else {
            return {
                [this.id]: JSON.stringify(this.dataParsed),
            };
        }
    }
}
